import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import { PreQueryFilterTransformer } from './pre-query-filter-transformer';
import { PreQueryRecentlyViewedTransformer } from './pre-query-recently-viewed-transformer';
import { RecentSearchesTransformer } from './recent-searches-transformer';
import { QueryFilterTransformer } from './query-filter-transformer';
import { PostQueryRecentlyViewedTransformer } from './post-query-recently-viewed-transformer';
import { DeduplicateRecentlyViewedAndResultsTransformer } from './deduplicate-recently-viewed-and-results-transformer';
export var QuickFindConfluenceTransformer = function QuickFindConfluenceTransformer(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(PreQueryFilterTransformer, rest, function (args) {
    return /*#__PURE__*/React.createElement(PreQueryRecentlyViewedTransformer, args, function (args) {
      return /*#__PURE__*/React.createElement(RecentSearchesTransformer, args, function (args) {
        return /*#__PURE__*/React.createElement(QueryFilterTransformer, args, function (args) {
          return /*#__PURE__*/React.createElement(PostQueryRecentlyViewedTransformer, args, function (args) {
            return /*#__PURE__*/React.createElement(DeduplicateRecentlyViewedAndResultsTransformer, args, function (args) {
              return children(args);
            });
          });
        });
      });
    });
  });
};